import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';
import { useActiveHomeTab } from './useActiveHomeTab';

/**
 * 탑 버튼(스크롤 최상단) 클릭 로깅 — `CLICK_SCROLL_TO_TOP`.
 *
 * **RN 이 직접 그리는 탑 버튼용**이다. 네이티브가 emit 하는 `scrollToTop`(하단탭 재선택,
 * 네이티브 플로팅 버튼) 경로는 `useNativeScrollToTop` 이 이미 같은 이벤트를 로깅한다.
 * 이 버튼은 `HomeScrollContext.scrollToTop()`(순수 JS)만 호출하므로 그 경로와 겹치지 않는다.
 *
 * - 채널은 `useNativeScrollToTop` 과 같게 맞춘다(ablylog / amplitude / firebase).
 * - 홈은 AnalyticsScreen 하위가 아니라 SCREEN 을 context 로 얻을 수 없어, 활성 탭의
 *   `screen_name` 을 쓴다(`useLogClickHomeFloatingButton` 과 같은 규칙).
 */
export const useLogClickScrollToTop = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  const activeTab = useActiveHomeTab();

  return useCallback(() => {
    logAnalyticsEvent({
      channel: ['ablylog', 'amplitude', 'firebase'],
      name: 'CLICK_SCROLL_TO_TOP',
      analytics: { SCREEN: activeTab?.screen_name ?? 'TODAY' },
    });
  }, [activeTab?.screen_name, logAnalyticsEvent]);
};
